import React, { useEffect, useState } from "react";
// import defaultImage from "../../assets/images/users/mobile-app.png";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import "flatpickr/dist/themes/material_blue.css";
import { getAppData } from "../../store/apps/actions";
import { withRouter } from "react-router-dom";
// import Select from "react-select";

const ApplicationSiteForm = props => {
  const [app_name, setAppName] = useState("");
  const [app_link, setAppLink] = useState("");

  useEffect(() => {
    return () => {
      setAppName("");
    };
  }, []);

  useEffect(() => {
    setAppName(prev => {
      if (props.app_data?.title != prev) {
        return props.app_data?.title;
      } else if (props.app?.name) {
        return props.app?.name;
      }
    });
  }, [props.app_data, props.app]);

  const handleLoadAppData = link => {
    props.getAppData(link);
    setAppLink(link);
  };

  const can_editable =
    (props.type === "edit" &&
      props.permissions["change_clientapplicationmodel"]) ||
    (props.type !== "edit" && props.permissions["add_clientapplicationmodel"]);

  return (
    <>
      <StyledRow className="d-flex justify-content-center">
        <Col sm={12}>
          <Row className="align-items-center">
            {/* <Col md={12} align="center">
              {props.loading ? (
                <Logotype className="avatar-lg profile-user-wid w-100 d-flex align-items-center justify-content-center">
                  <div
                    className="spinner-border text-primary m-1"
                    role="status"
                  />
                </Logotype>
              ) : (
                <Logotype className="avatar-lg profile-user-wid w-100 d-flex align-items-center justify-content-center">
                  <img
                    src={
                      props.app_data !== null &&
                      props.app_data.img !== undefined
                        ? props.app_data.img
                        : props.app?.app_picture || defaultImage
                    }
                    alt=""
                    style={{
                      maxHeight: "100%",
                    }}
                    className="img-thumbnail rounded-circle"
                    crossOrigin="Anonymous"
                  />
                </Logotype>
              )}
              <FormGroup>
                <AvField
                  name="app_picture"
                  className="form-control d-none"
                  id="app_picture"
                  // onChange={e => setAppName(e.target.value)}
                  value={
                    props.app_data !== null && props.app_data.img !== undefined
                      ? props.app_data.img
                      : props.app?.app_picture
                  }
                  readOnly
                />
              </FormGroup>
            </Col> */}
            <Col md={12}>
              <Row>
                <Col md={6}>
                  <Label htmlFor="formrow-password-Input">
                    Link to the website
                  </Label>
                  <FormGroup>
                    <AvField
                      name="app_link"
                      type="text"
                      value={props.app?.link || ""}
                      onChange={e => setAppLink(e.target.value)}
                      // onBlur={e =>
                      //   can_editable && handleLoadAppData(e.target.value)
                      // }
                      style={{
                        backgroundColor: "white !important",
                      }}
                      validate={{
                        required: { value: true },
                        minLength: {
                          value: 5,
                          errorMessage: "Please enter valid link",
                        },
                        maxLength: {
                          value: 255,
                        },
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Label htmlFor="formrow-email-Input">Website name</Label>
                  <FormGroup>
                    <AvField
                      name="app_name"
                      className="form-control"
                      id="formrow-email-Input"
                      value={props.app_data?.title || props.app?.name}
                      date={{
                        required: { value: true },
                        minLength: {
                          value: 3,
                          errorMessage: "Missing site name",
                        },
                        maxLength: {
                          value: 255,
                        },
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </StyledRow>
    </>
  );
};

const StyledRow = styled(Row)`
  .form-control:disabled {
    /* color: hsl(0, 0%, 60%); */
    background-color: #eff2f7;
    opacity: 1;
  }
`;

const Logotype = styled.div`
  margin-top: 0px;
  margin-bottom: 30px;
`;

ApplicationSiteForm.propTypes = {
  match: PropTypes.object,
  app_data: PropTypes.any,
  tracking_platforms: PropTypes.any,
  loading: PropTypes.bool,
  getAppData: PropTypes.func,
  onSubmitForm: PropTypes.func,
  app: PropTypes.any,
  type: PropTypes.string,
  changeStatusApp: PropTypes.func,
  permissions: PropTypes.any,
  setSelectedTracker: PropTypes.func,
  selectedTracker: PropTypes.any,
  dashboardTypes: PropTypes.array,
  setSelectDashboard: PropTypes.func,
  selectDashboard: PropTypes.any,
};

const mapStateToProps = state => ({
  loading: state.Apps.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getAppData,
})(withRouter(ApplicationSiteForm));
